import { DeleteDialog } from '@retail/components';
import UploadFreightConditionsDialog from './UploadFreightConditions/UploadFreightConditionsDialog';
import { usePermissionsForCurrentUser } from '@retail/app/stores/selected-context';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { useConditionActions } from '@retail/calculus/context';
import { ConditionsNew } from '@retail/calculus/types';
import { UniversalFormProvider } from '@shared/components';
import { createFreightConditionSchema } from '@retail/freight/components';
import CreateFreightCondition from './CreateFreightCondition';
import EditFreightConditionDialog from './EditFreightConditionDialog';

interface Props {
  supplierNumber?: number;
  createCondition: boolean;
  uploadConditions: boolean;
  editCondition?: ConditionsNew;
  deactivateConditionId?: number;
  deleteConditionId?: number;
  closeCreate: () => void;
  closeUpload: () => void;
  closeEdit: () => void;
  closeDeactivate: () => void;
  closeDelete: () => void;
}

export function FreightConditionActions({
  supplierNumber,
  createCondition,
  uploadConditions,
  editCondition,
  deactivateConditionId,
  deleteConditionId,
  closeCreate,
  closeUpload,
  closeEdit,
  closeDeactivate,
  closeDelete,
}: Props) {
  const t = useCalculusTFunction();
  const { removeCondition } = useConditionActions();

  const { userCanCreate, userCanUpdate } = usePermissionsForCurrentUser();
  const userCanCreateFreightConditions = userCanCreate('PRICE_CALCULATION__FREIGHT');
  const userCanUpdateFreightConditions = userCanUpdate('PRICE_CALCULATION__FREIGHT');

  return (
    <>
      {userCanCreateFreightConditions && createCondition && supplierNumber && (
        <UniversalFormProvider
          schema={createFreightConditionSchema(t)}
          defaultValues={createFreightConditionSchema(t).getDefault()}
        >
          <CreateFreightCondition open supplierNumber={supplierNumber} onClose={closeCreate} />
        </UniversalFormProvider>
      )}

      {userCanCreateFreightConditions && supplierNumber && (
        <UploadFreightConditionsDialog
          open={uploadConditions}
          onClose={closeUpload}
          supplierNumber={supplierNumber}
        />
      )}

      {userCanUpdateFreightConditions && editCondition && supplierNumber && (
        <EditFreightConditionDialog
          open
          supplierId={supplierNumber}
          freightConditionToEdit={editCondition}
          onClose={closeEdit}
        />
      )}
      {deactivateConditionId && (
        <DeleteDialog
          isOpen
          dialogTitle={t('calculus.actions.deactivateCondition')}
          message={t('calculus.actions.confirmRemoval')}
          onDelete={() => removeCondition([deactivateConditionId], 'deactivate')}
          onClose={closeDeactivate}
        />
      )}
      {deleteConditionId && (
        <DeleteDialog
          isOpen
          dialogTitle={t('calculus.actions.deleteFromDraft')}
          message={t('calculus.actions.confirmRemoval')}
          onDelete={() => removeCondition([deleteConditionId], 'delete')}
          onClose={closeDelete}
        />
      )}
    </>
  );
}
